var d64 = require("d64");
var uuid = require("uuid");

// El punto me trae problema en los ids, por lo que lo reemplazo por el "_".
// Si bien esto hace que sean menos identicos los id, me elimina el problema
exports.uid = () => d64.encode(uuid.parse(uuid.v4())).replaceAll(".", "_");
